module.exports = __webpack_public_path__ + "static/img/hover-2.0a4114aa.png";